function hasMethod(obj, name) {
  return typeof obj[name] === "function";
}
function getComponentElements(nameOrSelector, element = document) {
  const selector = `[data-component="${nameOrSelector}"]`;
  let elements = [];
  try {
    elements = Array.from(element.querySelectorAll(selector));
  } catch {
  }
  if (elements.length === 0) {
    elements = Array.from(element.querySelectorAll(nameOrSelector));
  }
  return elements;
}
export {
  getComponentElements,
  hasMethod
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
